module.exports = __webpack_public_path__ + "media/images/calendar-4f35fdc2fb5c670c87c6769e636f4252.svg";